import { render, staticRenderFns } from "./registSearchOrg.vue?vue&type=template&id=65d0a09e&scoped=true&"
import script from "./registSearchOrg.vue?vue&type=script&lang=js&"
export * from "./registSearchOrg.vue?vue&type=script&lang=js&"
import style0 from "./registSearchOrg.vue?vue&type=style&index=0&id=65d0a09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0a09e",
  null
  
)

export default component.exports